/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Timezones, TimezonesFromJSON } from '../models'
import * as runtime from '../runtime'

export interface FetchTimezonesRequest extends runtime.BaseRequestParameters {}

/**
 * TimezoneApi - interface
 *
 * @export
 * @interface TimezoneApiInterface
 */
export interface TimezoneApiInterface {
  /**
   *
   * @summary List of timezone names and their offset in the IANA time zone format i.e. America/Los_Angeles .
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TimezoneApiInterface
   */
  fetchTimezonesRaw(
    requestParameters: FetchTimezonesRequest
  ): Promise<runtime.ApiResponse<Timezones>>

  /**
   * List of timezone names and their offset in the IANA time zone format i.e. America/Los_Angeles .
   */
  fetchTimezones(): Promise<Timezones>
}

/**
 *
 */
export class TimezoneApi
  extends runtime.BaseAPI
  implements TimezoneApiInterface
{
  /**
   * List of timezone names and their offset in the IANA time zone format i.e. America/Los_Angeles .
   */
  async fetchTimezonesRaw(
    requestParameters: FetchTimezonesRequest
  ): Promise<runtime.ApiResponse<Timezones>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/timezones`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimezonesFromJSON(jsonValue)
    )
  }

  /**
   * List of timezone names and their offset in the IANA time zone format i.e. America/Los_Angeles .
   */
  async fetchTimezones(
    requestParameters?: FetchTimezonesRequest
  ): Promise<Timezones> {
    const response = await this.fetchTimezonesRaw(requestParameters || {})
    return await response.value()
  }
}
